import { Icons, useToggle } from '@commenda/kakashi';
import { FileBasic } from '@commenda/types/src/file/types';
import { getFileIcon, NonTimezoneSensitiveDate } from '@commenda/utils';
import FilePreviewModal from './FilePreviewModal';

export const FilingDocument = ({ file }: { file: FileBasic & { createdAt?: number } }) => {
  const previewCertificateModalVisibility = useToggle();

  const FileIconComponent: React.ElementType = getFileIcon(file.fileName);

  const formattedDate = NonTimezoneSensitiveDate.fromNativeDate(
    file?.createdAt ? new Date(Number(file?.createdAt) / 1000) : new Date()
  )?.format('MMM DD, YYYY');

  return (
    <>
      <div className="bg-bg-primary flex justify-between gap-md items-center p-lg rounded-md border border-border-primary">
        <div className="flex gap-lg items-center">
          <FileIconComponent className="size-10 text-icon-fg-brand shrink-0" />
          <div className="flex flex-col gap-xs">
            <span className="txt-small-medium">{file.fileName}</span>
            <span className="text-xs text-text-tertiary">{formattedDate}</span>
          </div>
        </div>
        <Icons.Eye
          onClick={previewCertificateModalVisibility.show}
          className="cursor-pointer size-5 text-fg-quaternary shrink-0"
        />
      </div>

      <FilePreviewModal
        isOpen={previewCertificateModalVisibility.visible}
        onClose={previewCertificateModalVisibility.hide}
        fileUrl={file.signedUrl}
        title={file.fileName}
      />
    </>
  );
};
